export const env = {
    apiUrl: import.meta.env.VITE_API_URL,
    statsApiUrl: import.meta.env.VITE_API_STATS_URL,
    awsUrl: import.meta.env.VITE_AWS_BUCKET_URL,
    googleApiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    // Local-only override. When set, the user dashboard renders as the
    // given user id instead of /users/self — handy for previewing how a
    // teammate's dashboard looks. Leave unset in non-local envs (e.g.
    // production / AWS) so the dashboard behaves normally.
    dashboardPreviewUserId:
        (import.meta.env.VITE_DASHBOARD_PREVIEW_USER_ID as
            | string
            | undefined) || null,
}
